var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-to-cart"},[_c('button',{staticClass:"btn btn-action",class:{disabled : !_vm.validCart},attrs:{"id":"customizer-add-to-cart-btn"},on:{"click":_vm.onAddToCart}},[_vm._v("Add to Cart")])])}
var staticRenderFns = []

export { render, staticRenderFns }